export var Name = 'update-delivery-channel';
export var UpdateDeliveryChannelEvent = Name;